import { create } from 'zustand';
import { createSelectors } from './createSelectors';
import { getInvite, InviteResponse, signIn, signOut, signUp } from '../apis/authApi';
import { useSessionStore } from './sessionStore';

interface AuthState {
  hasExistingLogin: boolean;
  email: string | null;
  customerId: string | null;
  getInvite: (inviteToken: string) => Promise<InviteResponse>;
  signUp: (inviteToken: string, password: string) => Promise<InviteResponse>;
  signIn: (username: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  signOutLocal: () => void;
}

const useAuthStoreBase = create<AuthState>((set, get) => ({
  hasExistingLogin: true,
  email: null,
  customerId: null,
  getInvite: async (inviteToken: string) => {
    const response = await getInvite(inviteToken);
    set({ customerId: response.customerId });
    set({
      email: response.email,
      hasExistingLogin: response.userExists,
    });
    return response;
  },

  signUp: async (inviteToken: string, password: string) => {
    const response = await signUp({
      inviteToken,
      password,
    });
    set({
      hasExistingLogin: response.userExists,
      customerId: response.customerId,
    });
    return response;
  },

  signIn: async (email: string, password: string) => {
    const response = await signIn({
      email,
      password,
      customerId: get().customerId,
    });
    useSessionStore.setState({
      isAuthenticated: true,
      email: response.email,
    });
    useSessionStore.getState().setCustomerData(response);
  },

  signOut: async () => {
    await signOut();
    get().signOutLocal();
  },

  signOutLocal: async () => {
    useSessionStore.getState().clearState();
  },
}));

export const useAuthStore = createSelectors(useAuthStoreBase);
